<template>

</template>

<script>
export default {
    name: 'eye-password',
    props: {
        field_id: {
            type: String,
            default: 'password',
        },
        eye_id: {
            type: String,
            default: 'eye',
        },
    },
    mounted() {
        let eye = document.getElementById(this.eye_id);
        let passField = document.getElementById(this.field_id);
        eye.addEventListener('click', e => {
            if (eye.classList.contains('fa-eye')) {
                eye.classList.remove('fa-eye');
                eye.classList.add('fa-eye-slash');
                passField.type = 'text';
            } else {
                eye.classList.remove('fa-eye-slash');
                eye.classList.add('fa-eye');
                passField.type = 'password';
            }
        });
    },
}
</script>
